<template>
    <el-main>
      <el-form ref="ruleForm" :model="data_form" label-width="100px" class="demo-ruleForm">
        <el-form-item label="微店头像:">
          <UploadSource :path="data_form.store_logo" @getSource="(data) => (data_form.store_logo = data.path)" @removeThis="data_form.store_logo = ''"></UploadSource>
        </el-form-item>
        <el-form-item label="微店名称:">
          <el-input placeholder="请输入" v-model="data_form.store_name"></el-input>
        </el-form-item>
        <el-form-item label="微店手机号:">
          <el-input placeholder="请输入" v-model="data_form.store_phone"></el-input>
        </el-form-item>
        <el-form-item label="联系人:">
          <el-input placeholder="请输入" v-model="data_form.contact_name"></el-input>
        </el-form-item>
        <!-- <el-form-item label="联系电话:">
            <el-input v-model="data_form.contact_phone"></el-input>
          </el-form-item> -->
        <el-form-item label="微店地址:">
          <div class="address_box">
            <el-input disabled placeholder="请定位" v-model="data_form.store_site"></el-input>
            <el-button type="primary" @click="() => (dialogMap = true)">定位</el-button>
          </div>
        </el-form-item>
        <el-form-item label="微店标签:">
          <template>
            <el-select v-model="data_form.tag_ids" multiple placeholder="请选择">
              <el-option v-for="tag in tag_list" :key="tag.id" :label="tag.label" :value="tag.id"></el-option>
            </el-select>
          </template>
        </el-form-item>
        <el-form-item label="微店介绍:">
          <el-input type="textarea" placeholder="请输入" :rows="3" v-model="data_form.store_intro"></el-input>
        </el-form-item>
        <el-form-item label="微店图片:">
          <UploadSource @getSource="getBannerImg" @changeOrder="changeOrder" @removeThis="removeImageThis" :isMany="true" :manyPath="data_form.store_banner" :isManyMax="9"></UploadSource>
        </el-form-item>
        <el-form-item label="营业执照:">
          <UploadSource :path="data_form.business_license" @getSource="(data) => (data_form.business_license = data.path)" @removeThis="data_form.business_license = ''"></UploadSource>
        </el-form-item>
      </el-form>
  
      <el-dialog title="选择坐标" :visible.sync="dialogMap">
        <Map ref="map" :lng="data_form.store_longitude" :lat="data_form.store_latitude"></Map>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogMap = false">取 消</el-button>
          <el-button type="primary" @click="confirmCoordinate">确 定</el-button>
        </div>
      </el-dialog>
  
      <Preservation @preservation="addStoreBtn"></Preservation>
    </el-main>
  </template>
  
  <script>
  import UploadSource from '@/components/readyUploadSource.vue';
  import Map from '@/components/Map.vue';
  import Preservation from '@/components/preservation.vue';
  import _ from 'lodash';
  export default {
    components: {
      UploadSource,
      Map,
      Preservation,
    },
    data() {
      return {
        store_id: null,
        data_form: {
          contact_name: '',
          store_logo: '',
          store_name: '',
          store_phone: '',
          store_site: '',
          business_license: '',
          store_intro: '',
          store_latitude: null,
          store_longitude: null,
          store_banner: [],
          tag_ids: [],
        },
        dialogMap: false,
        tag_list: [],
        tag_choose_hash: {},
      };
    },
    created() {
      this.getStoreInfo();
      this.getTagList();
    },
    methods: {
      getStoreInfo() {
        this.$axios.post(this.$api.user.shopInfo).then((res) => {
          if (res.code == 0) {
            for (const key in this.data_form) {
              if(key === 'store_banner' || key == 'tag_ids')continue
                  else this.data_form[key] = res.result[key]
            }
            this.data_form.store_name = res.result.merchant_name
            this.data_form.store_latitude = res.result.lat
            this.data_form.store_longitude = res.result.lng
            this.data_form.store_intro = res.result.intro
            this.data_form.store_banner = res.result.store_banners
            res.result.tag_list.map(tag =>{
              this.data_form.tag_ids.push(tag.new_tag_id)
            })
          } else {
            this.$message.error(res.msg);
          }
        });
      },
      // 获取车辆定位
      confirmCoordinate() {
        let coordinate = this.$refs.map.currentCoordinate;
        let obj = this.$refs.map.address;
        if (!obj) {
          this.$message.warning('请输入定位地址');
          return;
        }
        this.data_form.store_site = obj.province + obj.city + obj.district + obj.street + obj.streetNumber + this.$refs.map.search;
        this.data_form.store_longitude = coordinate.lng;
        this.data_form.store_latitude = coordinate.lat;
        this.dialogMap = false;
      },
      getTagList() {
        let obj = {
          page: 1,
          rows: 100,
        };
        this.$axios.post(this.$api.store.tagList, obj).then((res) => {
          if (res.code === 0) {
            res.result.list.map((tag) => {
              this.tag_choose_hash[tag.id] = 0;
            });
            this.tag_list = res.result.list;
          }
        });
      },
      // 获取选中的图片
      getBannerImg(val) {
        val.map((img) => {
          this.data_form.store_banner.push(img.path);
        });
      },
      // 拖动重新赋值车辆图片顺序
      changeOrder(list) {
        this.data_form.store_banner = list;
      },
      // 移除某张图片
      removeImageThis(index) {
        this.data_form.store_banner.splice(index, 1);
      },
      // 点击添加门店
      addStoreBtn() {
        let flag = true;
        for (const key in this.data_form) {
          if (key == 'tag_ids' || key == 'store_banner') {
            if (this.data_form[key].length === 0) {
              flag = false;
              break;
            }
          }
          if (!this.data_form[key]) {
            flag = false;
            break;
          }
        }
        if (!flag) {
          this.$message.warning('请将数据填写完整');
          return;
        }
        let obj = _.cloneDeep(this.data_form);
        let url = this.$api.store.edit;
        let str = '保存成功';
        this.$axios.post(url, obj).then((res) => {
          if (res.code == 0) {
            this.$message.success(str);
          } else {
            this.$message.error(res.msg);
          }
        });
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .el-main {
    width: 100%;
    height: 100%;
    background-color: #fff;
    user-select: none;
    padding-bottom: 80px;
    .el-input,
    .el-textarea,
    .el-select {
      width: 400px;
    }
    .address_box {
      display: flex;
    }
    .tag_box {
      width: 500px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .tag {
        font-weight: 400;
        font-size: 18px;
        color: #fff;
        height: 34px;
        padding: 0 16px;
        margin-bottom: 8px;
        margin-right: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  </style>
  